import { render, staticRenderFns } from "./businessGoodDetail.vue?vue&type=template&id=6076b298&scoped=true&"
import script from "./businessGoodDetail.vue?vue&type=script&lang=js&"
export * from "./businessGoodDetail.vue?vue&type=script&lang=js&"
import style0 from "./businessGoodDetail.vue?vue&type=style&index=0&id=6076b298&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6076b298",
  null
  
)

export default component.exports